import { GoodsEntity, PolicyEntity, PriceEntity, ProductEntity } from "./Policy";

export class OrderResolveModel {
  BuildTradeDetails = true;
  UniqueID?: string;
  SupplyID?: string;
  SupplyName?: string;
  SupplyUniqueID?: string;
  Vouchers?: OrderVoucherEntity[];
  PaymentAmount?: number;
  ReceiveAmount?: number;
  Discount?: number;
  Fare?: number;
  Reward?: number;
  transactionid?: string; //火车交易单号
  ordernumber?: string; //火车取票单号
  ConsumerAddress?: string; //火车检票口
  TrainCosumers?: TrainCosumer[];
  ProfitLossReason?: string;
  Relates?: OrderRelateionEntity;
}
export class TrainCosumer {
  ConsumerName?: string;
  CardNo?: string;
  zwname?: string;
  ticket_no?: string;
  cxin?: string;
  price?: number;
}
export class OrderConsumerEntity {
  IsSave?: boolean;
  ///<summary>消费者编号
  ///</summary>
  ConsumerID?: string;
  ///<summary>原始订单
  ///</summary>
  OriginID?: string;
  ///<summary>唯一编号
  ///</summary>
  UniqueID?: string;
  ///<summary>订单编号
  ///</summary>
  OrderID?: string;
  ///<summary>用户编号
  ///</summary>
  UserID?: string;
  ConsumerNo?: string;

  ///<summary>消费者名称
  ///</summary>
  ConsumerName?: string;
  ///<summary>英文姓
  ///</summary>
  EnglishFirstName?: string;
  ///<summary>英文名
  ///</summary>
  EnglishLastName?: string;
  ///<summary>消费者类型
  ///</summary>
  ConsumerType?: number;
  ///<summary>性别
  ///</summary>
  ConsumerSex?: number;
  CountryID?: number;
  CountryCode?: string;
  ///<summary>出生日期
  ///</summary>
  Birthday?: Date;
  BirthdayEnd?: Date;
  ///<summary>证件类型
  ///</summary>
  CardType?: number;
  ///<summary>证件号
  ///</summary>
  CardNo?: string;
  ///<summary>证件过期日期
  ///</summary>
  CardOverDate?: Date;
  CardOverDateEnd?: Date;
  ///<summary>联系电话
  ///</summary>
  ContactMobile?: string;
  ///<summary>联系邮箱
  ///</summary>
  ContactEmail?: string;
  ///<summary>消费偏好
  ///</summary>
  ConsumerPreference?: string;
  ///<summary>供应订单号
  ///</summary>
  SupplyConsumerID?: string;
  ///<summary>客户订单编号
  ///</summary>
  ClientConsumerID?: string;
  ///<summary>消费者数据
  ///</summary>
  ConsumerData?: string;
  ///<summary>创建时间
  ///</summary>
  CreateTime?: Date;
  CreateTimeEnd?: Date;
  ///<summary>创建人编号
  ///</summary>
  CreateUserID?: string;
  ///<summary>创建人编号
  ///</summary>
  CreateUserName?: string;
  ///<summary>修改时间
  ///</summary>
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserID?: string;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserName?: string;
  SupplyOriginID?: string;
  ClientOriginID?: string;
  NotifyType?: string;

  ///<summary>消费者编号
  ///</summary>
}

export class OrderEntity {
  PageNo?: number;
  Goods?: any[];
  Consumers?: OrderConsumerEntity[];
  Policys?: any[];
  Vouchers?: OrderVoucherEntity[];
  Products?: any[];
  Prices?: any[];
  Options?: OrderOptionsEntity[];
  ExtraInfos?: OrderExtraInfoEntity[];

  OrderInvoice?: OrderInvoiceEntity;
  InvoiceEntity?: OrderInvoiceEntity[];
  IsClient?: boolean;
  IsSupply?: boolean;
  IsOrder?: boolean;
  BusinessTypes?: number[];
  TaskIDs?: string[];
  AddressID?: string;
  InvoiceOrder?: any;
  Price?: number;
  ///<summary>唯一编号
  ///</summary>
  UniqueID?: string;
  ///<summary>订单编号
  ///</summary>
  OrderID?: string;
  ///<summary>原始订单
  ///</summary>
  OriginID?: string;
  ///<summary>原订单号
  ///</summary>
  OriginOrderID?: string;
  ///<summary>公司编号
  ///</summary>
  CompanyID?: string;
  ///<summary>供应名称
  ///</summary>
  CompanyName?: string;
  ///<summary>区域类型
  ///</summary>
  ApplyArea?: number;
  ///<summary>订单类型 销售 改签
  ///</summary>
  OrderType?: number;
  ///<summary>业务单号
  ///</summary>
  BusinessID?: string;
  ///<summary>服务编号
  ///</summary>
  ServiceID?: string;
  ///<summary>产品类型 机票 酒店 旅游
  ///</summary>
  ServiceType?: number;
  ///<summary>业务类型
  ///</summary>
  BusinessType?: number;
  ///<summary>之前状态
  ///</summary>
  BeforeStatus?: number;
  ///<summary>订单状态
  ///</summary>
  OrderStatus?: number;
  ///<summary>状态名称
  ///</summary>
  StatusName?: string;
  ///<summary>产品品牌
  ///</summary>
  ProduceID?: string;
  ///<summary>品牌代码
  ///</summary>
  ProduceCode?: string;
  ///<summary>品牌名称
  ///</summary>
  ProduceName?: string;
  ///<summary>产品编号
  ///</summary>
  ProductID?: string;
  ///<summary>产品代码
  ///</summary>
  ProductCode?: string;
  ///<summary>产品名称
  ///</summary>
  ProductName?: string;
  ///<summary>主图
  ///</summary>
  ProductImage?: string;
  ///<summary>旅客数量
  ///</summary>
  ProductCount?: number;
  ///<summary>产品级别(等级 规格)
  ///</summary>
  LevelID?: string;
  ///<summary>级别代码
  ///</summary>
  LevelCode?: string;
  ///<summary>级别名称 头等舱 商务舱 经济舱 9折经济舱 8折经济舱
  ///</summary>
  LevelName?: string;
  ///<summary>产品批次(团号 航班号 批次号 印刷批次)
  ///</summary>
  BatchID?: string;
  ///<summary>产品批次(团号 航班号 批次号 印刷批次)
  ///</summary>
  BatchCode?: string;
  ///<summary>下单方式(线上或门店)
  ///</summary>
  CreateMode?: number;
  ///<summary>消费日期
  ///</summary>
  ConsumerDate?: Date;
  ConsumerDateEnd?: Date;
  ///<summary>消费者名称
  ///</summary>
  ConsumerName?: string;
  ///<summary>消费目的
  ///</summary>
  ConsumerIntent?: string;
  ///<summary>搜索索引
  ///</summary>
  KeyWords?: string;
  ///<summary>联系人编号
  ///</summary>
  ContactID?: string;
  ///<summary>联系人姓名
  ///</summary>
  ContactName?: string;
  ///<summary>联系人电话
  ///</summary>
  ContactPhone?: string;
  ///<summary>联系人邮箱
  ///</summary>
  ContactEmail?: string;
  ///<summary>供应编号
  ///</summary>
  SupplyID?: string;
  ///<summary>供应名称
  ///</summary>
  SupplyName?: string;
  ///<summary>客户级别
  ///</summary>
  SupplyLevel?: string;
  ///<summary>供应订单号
  ///</summary>
  SupplyUniqueID?: string;
  ///<summary>供应联系人编号
  ///</summary>
  SupplyContactID?: string;
  ///<summary>供应联系人名称
  ///</summary>
  SupplyContactName?: string;
  ///<summary>供应联系人电话
  ///</summary>
  SupplyContactPhone?: string;
  ///<summary>供应联系人邮箱
  ///</summary>
  SupplyContactEmail?: string;
  SupplyOrderStatus?: number;
  ///<summary>供应订单状态名称
  ///</summary>
  SupplyStatusName?: string;
  ///<summary>收款总金额
  ///</summary>
  PaymentAmount?: number;
  ///<summary>收款状态
  ///</summary>
  PaymentStatus?: number;
  ///<summary>付款状态名称
  ///</summary>
  PaymentStatusName?: string;
  ///<summary>收款时间
  ///</summary>
  PaymentTime?: Date;
  ///<summary>付款方式
  ///</summary>
  PaymentMode?: number;
  ///<summary>最后付款时间
  ///</summary>
  LastPaymentTime?: Date;
  LastPaymentTimeEnd?: Date;
  ///<summary>客户编号
  ///</summary>
  ClientID?: string;
  ///<summary>客户名称
  ///</summary>
  ClientName?: string;
  ///<summary>客户级别
  ///</summary>
  ClientLevel?: string;
  ///<summary>客户联系人编号
  ///</summary>
  ClientContactID?: string;
  ///<summary>客户联系人名称
  ///</summary>
  ClientContactName?: string;
  ///<summary>客户联系人电话
  ///</summary>
  ClientContactPhone?: string;
  ///<summary>客户联系人邮箱
  ///</summary>
  ClientContactEmail?: string;
  ///<summary>客户订单编号
  ///</summary>
  ClientUniqueID?: string;
  ///<summary>订单状态
  ///</summary>
  ClientOrderStatus?: number;
  ///<summary>客户订单状态名称
  ///</summary>
  ClientStatusName?: string;
  ///<summary>收款总金额
  ///</summary>
  ReceiveAmount?: number;
  ///<summary>收款状态
  ///</summary>
  ReceiveStatus?: number;
  ///<summary>收款状态名称
  ///</summary>
  ReceiveStatusName?: string;
  ///<summary>收款时间
  ///</summary>
  ReceiveTime?: Date;
  ReceiveTimeEnd?: Date;
  ///<summary>收款方式
  ///</summary>
  ReceiveMode?: number;
  ///<summary>出票时间
  ///</summary>
  DoneUserID?: string;
  ///<summary>出票时间
  ///</summary>
  DoneUserName?: string;
  ///<summary>出票时间
  ///</summary>
  DoneTime?: Date;
  DoneTimeEnd?: Date;
  ///<summary>锁定人编号
  ///</summary>
  LockUserID?: string;
  ///<summary>锁定人名称
  ///</summary>
  LockUserName?: string;
  ///<summary>锁定时间
  ///</summary>
  LockTime?: Date;
  LockTimeEnd?: Date;
  ///<summary>超时时间
  ///</summary>
  OverTime?: Date;
  OverTimeEnd?: Date;
  ///<summary>特性代码
  ///</summary>
  FeatureCodes?: string;
  ///<summary>交易角色
  ///</summary>
  TradeRole?: string;
  ///<summary>数据级别代码
  ///</summary>
  DataLevelCode?: string;
  ///<summary>备注
  ///</summary>
  Remark?: string;
  ///<summary>创建时间
  ///</summary>
  CreateTime?: Date;
  CreateTimeEnd?: Date;
  ///<summary>创建人编号
  ///</summary>
  CreateUserID?: string;
  ///<summary>创建人编号
  ///</summary>
  CreateUserName?: string;
  ///<summary>修改时间
  ///</summary>
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserID?: string;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserName?: string;
  SupplyOriginID?: string;
  ClientOriginID?: string;
  ReasonType?: string;
  Reason?: string;
  ReasonDetail?: string;
  ///<summary>收款总额（包含附加产品）
  ///</summary>
  ReceiveTradeAmount?: number;
  ///<summary>付款总额（包含附加产品）
  ///</summary>
  PaymentTradeAmount?: number;

  ///<summary>消费地址
  ///</summary>
  ConsumerCityCode?: string;
  ///<summary>消费地址
  ///</summary>
  ConsumerCityName?: string;
  ///<summary>消费地址
  ///</summary>
  ConsumerZoneCode?: string;
  ///<summary>消费地址
  ///</summary>
  ConsumerZoneName?: string;
  ///<summary>消费地址
  ///</summary>
  ConsumerAddress?: string;
  ///<summary>消费地址
  ///</summary>
  FinishedCityCode?: string;
  ///<summary>消费地址
  ///</summary>
  FinishedCityName?: string;
  ///<summary>消费地址
  ///</summary>
  FinishedZoneCode?: string;
  ///<summary>消费地址
  ///</summary>
  FinishedZoneName?: string;
  ///<summary>消费日期
  ///</summary>
  FinishedDate?: string;
  ///<summary>消费地址
  ///</summary>
  FinishedAddress?: string;
  ///<summary>消费时间(飞行时间)
  ///</summary>
  ConsumerDuration?: string;

  UnionID?: string;
  ConsumerDates?: string;
  ProfitLoss?: number;
  BookingUserID?: string;
  BookingUserName?: string;
  ProfitLossReason?: string;
  ///<summary>偏好
  ///</summary>
  Preference?: string;

  /// <summary>
  /// 保留时间
  /// </summary>
  RetentionTime?: Date;

  RetentionTimeEnd?: Date;
}
export class OrderExtraInfoEntity {
  ExtraID?: string;
  ///<summary>扩展名称
  ///</summary>
  ExtraName?: string;
  ///<summary>扩展数据
  ///</summary>
  ExtraData?: string;
  ///<summary>扩展代码
  ///</summary>
  ExtraCode?: string;
  ///<summary>扩展组号(扩展行记录)
  ///</summary>
  ExtraGroup?: string;
  ///<summary>格式代码(text html url json xml)
  ///</summary>
  FormatCode?: string;
  ///<summary>目标编号
  ///</summary>
  IncludeID?: string;
  ///<summary>主要信息
  ///</summary>
  MasterID?: string;
  ///<summary>额外扩展(width)
  ///</summary>
  ExtraDataX?: string;
  ///<summary>额外扩展(height)
  ///</summary>
  ExtraDataY?: string;
  ///<summary>额外扩展(depth)
  ///</summary>
  ExtraDataZ?: string;
}
export class OrderGoodsEntity extends GoodsEntity {
  SupplyOriginID?: string;
  ClientOriginID?: string;
}
export class OrderInvoiceEntity {
  Addressee?: string;
  ContactNumber?: string;
  AddressInfo?: string;
  ProvinceID?: number;
  CityID?: number;
  AreaID?: number;
  ///<summary>发票编号
  ///</summary>
  InvoiceID?: string;
  ///<summary>订单编号
  ///</summary>
  OrderID?: string;
  ///<summary>发票类型
  ///</summary>
  InvoiceType?: string;
  ///<summary>发票明细
  ///</summary>
  Details?: string;
  ///<summary>配送方式
  ///</summary>
  Delivery?: string;
  ///<summary>快递费用
  ///</summary>
  Cost?: number;
  TitleType?: string;
  ///<summary>发票抬头
  ///</summary>
  Title?: string;
  TaxNumber?: string;
  AddressID?: string;
  TitleID?: string;

  ///<summary>发票编号
  ///</summary
}
export class OrderOptionsEntity {
  ///<summary>商品编号
  ///</summary>
  OptionsID?: string;
  ///<summary>政策编号
  ///</summary>
  GoodsID?: string;
  ///<summary>产品编号
  ///</summary>
  ProductID?: string;
  ///<summary>政策编号
  ///</summary>
  SourceID?: string;
  ///<summary>唯一编号
  ///</summary>
  UniqueID?: string;
  ///<summary>订单编号
  ///</summary>
  OrderID?: string;
  ///<summary>规格类型
  ///</summary>
  OptionsType?: number;
  ///<summary>规格代码
  ///</summary>
  OptionsCode?: string;
  ///<summary>规格名称(256G 黑色)
  ///</summary>
  OptionsName?: string;
  ///<summary>规格顺序
  ///</summary>
  OptionsOrder?: number;
  ///<summary>创建时间
  ///</summary>
  CreateTime?: Date;
  CreateTimeEnd?: Date;
  ///<summary>创建人编号
  ///</summary>
  CreateUserID?: string;
  ///<summary>创建人编号
  ///</summary>
  CreateUserName?: string;
  ///<summary>修改时间
  ///</summary>
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserID?: string;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserName?: string;

  ///<summary>商品编号
  ///</summary>
}
export class OrderPolicyEntity extends PolicyEntity {
  SupplyUniqueID?: string;
  SupplyOrderStatus?: number;
  ClientUniqueID?: string;
  ClientOrderStatus?: number;
  SupplyOriginID?: string;
  ClientOriginID?: string;
  IsTwoConfirm?: number;
}
export class OrderPriceEntity extends PriceEntity {
  SupplyOriginID?: string;
  ClientOriginID?: string;
}
export class OrderProductEntity extends ProductEntity {
  SupplyOriginID?: string;
  ClientOriginID?: string;
}
export class OrderRelateionEntity {
  UniqueID?: string;
  GoodsID?: string;
  OrderID?: string;
  ///<summary>凭证编号
  ///</summary>
  VoucherID?: string;
  ///<summary>旅客编号
  ///</summary>
  ConsumerID?: string;
}
export class OrderVoucherEntity {
  ///<summary>凭证编号
  ///</summary>
  VoucherID?: string;
  ///<summary>原始订单
  ///</summary>
  OriginID?: string;
  ///<summary>政策编号
  ///</summary>
  PolicyID?: string;
  ///<summary>产品编号
  ///</summary>
  ProductID?: string;
  ///<summary>商品编号
  ///</summary>
  GoodsID?: string;
  ///<summary>消费者编号
  ///</summary>
  ConsumerID?: string;
  ///<summary>唯一编号
  ///</summary>
  UniqueID?: string;
  ///<summary>订单编号
  ///</summary>
  OrderID?: string;
  ///<summary>处理状态
  ///</summary>
  DealState?: number;
  ///<summary>凭证代码(票号 房号 座位号 商品条码等)
  ///</summary>
  VoucherNo?: string;
  ///<summary>凭证类型
  ///</summary>
  VoucherType?: number;
  ///<summary>凭证名称
  ///</summary>
  VoucherName?: string;
  ///<summary>凭证数据
  ///</summary>
  VoucherData?: string;
  ///<summary>供应订单号
  ///</summary>
  SupplyVoucherID?: string;
  ///<summary>客户订单编号
  ///</summary>
  ClientVoucherID?: string;
  ///<summary>创建时间
  ///</summary>
  CreateTime?: Date;
  CreateTimeEnd?: Date;
  ///<summary>创建人编号
  ///</summary>
  CreateUserID?: string;
  ///<summary>创建人编号
  ///</summary>
  CreateUserName?: string;
  ///<summary>修改时间
  ///</summary>
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserID?: string;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserName?: string;
  SupplyOriginID?: string;
  ClientOriginID?: string;

  ///<summary>凭证编号
  ///</summary>
}

export class AmendEntity extends OrderEntity {
  SupplyAmendID?: string;
  ClientAmendID?: string;
  ///<summary>原因类别
  ///</summary>
  ReasonType?: string;
  ///<summary>退改理由
  ///</summary>
  AmendReason?: string;
}
